import { h } from 'preact';
import React, { Component } from 'react';
import SpatialNavigation from 'spatial-navigation-js';

import { PMButtonSettings } from './PMButtonSettings';
import { makeText, languageUsed, isActionAllowed } from '../../util';
import { actionTypes } from '../../constants';

import './PMButton.css';
export class PMButton extends Component {
  componentDidUpdate = (prevProps) => {
    if (!prevProps.shown && this.props.shown) {
      const { startFocus } = this.props.component.settings;
      if (startFocus) {
        SpatialNavigation.clear();
        SpatialNavigation.add({
          selector: '.start-focus',
          defaultElement: '.start-focus',
        })
        setTimeout(() => {
          SpatialNavigation.focus()
        }, 50)
      };
    }
  }

  makeChoice = (e) => {
    if ((this.props.isOtt && e.type === 'click') || (this.props.isOtt && e.keyCode !== 13)) {
      return
    }
    const { language, component: { settings } } = this.props;
    const choice = settings.action_type;
    if (choice) {
      if (choice.type === 9) {
        return this.props.makeChoice(choice.type, languageUsed(language, settings, 'text'), false, choice.data);
      }

      this.props.makeChoice(actionTypes[choice], languageUsed(language, new PMButtonSettings(settings), 'text'));
    };
  }

  render() {
    const settings = new PMButtonSettings(this.props.component.settings);

    const { language, dev, isOtt, neutralPm, allSelectionsMade } = this.props;

    const disable = neutralPm && settings.action_type === 'SAVE_AND_EXIT' && !allSelectionsMade

    const styles = {
      opacity: disable ? .5 : 1,
      ...settings.padding,
      ...settings.margin,
      ...settings.border,
      ...settings.font
    };

    /* WIDTH & HEIGHT */
    const { paddingLeft, paddingRight } = settings.padding;
    const { marginLeft, marginRight } = settings.margin;

    styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
    if (settings.width.type === '%') {
      styles.width = `calc(${settings.width.value}% - ${(paddingLeft + paddingRight + marginLeft + marginRight)}px`;
    };

    styles.background = settings.background;

    /* DEV MODE ONLY */
    let devActions = {};
    let selected = false;
    let path = JSON.stringify(this.props.path);
    if (dev) {
      devActions = { ...dev.hover };
      selected = dev.current === path;
    }

    let className = 'message-component message-button no-children focusable ' + (settings.startFocus ? 'start-focus' : '') + this.props.className;
    const btnText = makeText(dev, settings, 'text', language);

    const getChoiceOptionClass = () => {
      const choiceOption = this.props.component.settings;
      const type = choiceOption ? choiceOption.action_type : null;
      return type ? `sp_choice_type_${type}` : ''
    }

    className += ' ' + getChoiceOptionClass();

    return (
      <button
        aria-disabled={disable}
        disabled={disable}
        title={btnText}
        aria-label={btnText}
        onClick={!isOtt ? this.makeChoice : undefined}
        onKeyDown={(e) => isActionAllowed(e.key) && this.makeChoice(e)}
        className={selected ? className + ' on-active' : className}
        path={dev ? path : null}
        style={styles}
        {...devActions}
      >
        {btnText}
      </button>
    );
  }
}